var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sqr",
                    expression: "'sqr'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("sqr"),
                  name: "flowName",
                  label: "申请人",
                  placeholder: "申请人",
                  "input-align": "right",
                  rules: _vm.getRules("sqr"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.sqr,
                            placeholder: "请选择申请人",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.sqr,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sqr", $$v)
                  },
                  expression: "formData.sqr",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "关联业务",
                  placeholder: "请选择项目/合同",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm.split(",")[1],
                            placeholder: "请选择项目/合同",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目/合同",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.businessSelectFinish("ssxm")
                                },
                              },
                            }),
                            _c(
                              "van-row",
                              {
                                staticClass: "p-r-20",
                                attrs: { type: "flex", align: "center" },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.ssxm,
                                            "name",
                                            "columnsLabel"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.ssxm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ssxm, "filterText", $$v)
                                        },
                                        expression: "ssxm.filterText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "van-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "van-button",
                                      {
                                        attrs: {
                                          loading: _vm.btnLoading,
                                          "loading-text": "加载中...",
                                          type: "primary",
                                          "native-type": "button",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectMyProjectList(
                                              "",
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("更多项目... ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "columnsLabel",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                change: _vm.onChange,
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  label: "成本归属部门",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.deptcost,
                  callback: function ($$v) {
                    _vm.deptcost = $$v
                  },
                  expression: "deptcost",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxsy",
                    expression: "'bxsy'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("bxsy"),
                  required: _vm.isRequired("bxsy"),
                  name: "bxsy",
                  rules: _vm.getRules("bxsy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "报销事由",
                  "show-word-limit": "",
                  placeholder: "请输入报销事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bxsy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bxsy", $$v)
                  },
                  expression: "formData.bxsy",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "skrfkbz",
                    expression: "'skrfkbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("skrfkbz"),
                  required: _vm.isRequired("skrfkbz"),
                  rules: _vm.getRules("skrfkbz"),
                  name: "skrfkbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "付款备注",
                  "show-word-limit": "",
                  placeholder:
                    "请在填写付款备注时，避免使用 “福利、劳务费、工资、薪贴、奖金” 等相关表述。",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.skrfkbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "skrfkbz", $$v)
                  },
                  expression: "formData.skrfkbz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "skrbz",
                    expression: "'skrbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("skrbz"),
                  required: _vm.isRequired("skrbz"),
                  rules: _vm.getRules("skrbz"),
                  name: "skrbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.skrbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "skrbz", $$v)
                  },
                  expression: "formData.skrbz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "zmlx",
                    expression: "'zmlx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "zmlx",
                  required: _vm.isRequired("zmlx"),
                  rules: _vm.getRules("zmlx"),
                  label: "账套类型",
                  placeholder: "请选择账套类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("zmlx")
                          ? _c("view-item", {
                              attrs: { showLabel: _vm.formData.zmlx },
                            })
                          : _c(
                              "van-checkbox-group",
                              {
                                staticStyle: { display: "flex" },
                                model: {
                                  value: _vm.formData.zmlx,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "zmlx", $$v)
                                  },
                                  expression: "formData.zmlx",
                                },
                              },
                              [
                                _c(
                                  "van-checkbox",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: { name: "管理账套" },
                                  },
                                  [_vm._v("管理账套")]
                                ),
                                _c(
                                  "van-checkbox",
                                  { attrs: { name: "核算账套" } },
                                  [_vm._v("核算账套")]
                                ),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "hsgs",
                    expression: "'hsgs'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "hsgs",
                  required: _vm.isRequired("hsgs"),
                  value: _vm.formData.hsgs,
                  rules: _vm.getRules("hsgs"),
                  label: "所属核算公司",
                  placeholder: "请选择核算公司",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.hsgs,
                            placeholder: "请选择核算公司",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.hsgs, "hsgs")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.hsgs.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.hsgs, "show", $$v)
                              },
                              expression: "hsgs.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择核算公司",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.hsgs.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("hsgs", {
                                    label: "name",
                                    value: "id",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.hsgs,
                                    "name"
                                  )
                                },
                              },
                              model: {
                                value: _vm.hsgs.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.hsgs, "filterText", $$v)
                                },
                                expression: "hsgs.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "hsgs",
                              attrs: {
                                duration: 0,
                                "value-key": "name",
                                columns: _vm.hsgs.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.hsgs.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "startFlowDate",
                    expression: "'startFlowDate'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("startFlowDate"),
                  name: "startFlowDate",
                  label: "报销日期",
                  placeholder: "报销日期",
                  "input-align": "right",
                  rules: _vm.getRules("startFlowDate"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.startFlowDate,
                            placeholder: "请选择报销日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.startFlowDate,
                                "startFlowDate"
                              )
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "startFlowDate",
                          attrs: {
                            "min-date": _vm.startFlowDate.minDate,
                            "max-date": _vm.startFlowDate.maxDate,
                            "show-confirm": false,
                            title: "选择报销日期",
                          },
                          on: { confirm: _vm.startFlowDateConfirm },
                          model: {
                            value: _vm.startFlowDate.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.startFlowDate, "show", $$v)
                            },
                            expression: "startFlowDate.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.startFlowDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "startFlowDate", $$v)
                  },
                  expression: "formData.startFlowDate",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "jdzsfymxb",
                  expression: "'jdzsfymxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("酒店住宿费用")]
              ),
              _vm._l(_vm.formData.jdzsfymxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`酒店住宿费用明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("jdzsfymxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(
                                          index,
                                          "jdzsfymxb"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "cccs",
                          expression: "'cccs'",
                        },
                      ],
                      attrs: {
                        name: "cccs",
                        required: _vm.isRequired("cccs"),
                        rules: _vm.getRules("cccs"),
                        label: "出差城市",
                        placeholder: "出差城市",
                        "input-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.cccs,
                                    placeholder: "请选择出差城市",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.cccs.show,
                                        index,
                                        "cccs"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.cccs.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.cccs.show, index, $$v)
                                      },
                                      expression: "cccs.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择出差城市",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.cccs.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.cccsPopupSubmit(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`cccsTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.cccs.filterText[index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.cccs.filterText,
                                            index,
                                            $$v
                                          )
                                        },
                                        expression: "cccs.filterText[index]",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `cccsTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.cccs.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `cccsTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.cccs,
                        callback: function ($$v) {
                          _vm.$set(item, "cccs", $$v)
                        },
                        expression: "item.cccs",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "sfhz",
                          expression: "'sfhz'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "sfhz",
                        rules: _vm.getRules("sfhz"),
                        required: _vm.isRequired("sfhz"),
                        value: item.sfhz,
                        label: "是否合住",
                        placeholder: "请选择是否合住",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.sfhz,
                                    placeholder: "请选择是否合住",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.sfhz.show,
                                        index,
                                        "sfhz"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.sfhz.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.sfhz.show, index, $$v)
                                      },
                                      expression: "sfhz.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择是否合住",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.sfhz.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.sfhzSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.sfhz
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.sfhz.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.sfhz, "filterText", $$v)
                                        },
                                        expression: "sfhz.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `sfhzPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.sfhz.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.sfhz.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "rzrq",
                          expression: "'rzrq'",
                        },
                      ],
                      attrs: {
                        required: _vm.isRequired("rzrq"),
                        name: "rzrq",
                        label: "入住日期",
                        placeholder: "入住日期",
                        "input-align": "right",
                        rules: _vm.getRules("rzrq"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.rzrq,
                                    placeholder: "请选择入住日期",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.rzrq.show,
                                        index,
                                        "rzrq"
                                      )
                                    },
                                  },
                                }),
                                _c("van-calendar", {
                                  ref: "rzrq",
                                  refInFor: true,
                                  attrs: {
                                    "min-date": _vm.ccsj.minDate,
                                    "show-confirm": false,
                                    title: "选择入住日期",
                                  },
                                  on: {
                                    confirm: (date) => {
                                      _vm.rzrqConfirm(date, item, index)
                                    },
                                  },
                                  model: {
                                    value: _vm.rzrq.show[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.rzrq.show, index, $$v)
                                    },
                                    expression: "rzrq.show[index]",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.rzrq,
                        callback: function ($$v) {
                          _vm.$set(item, "rzrq", $$v)
                        },
                        expression: "item.rzrq",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "ldrq",
                          expression: "'ldrq'",
                        },
                      ],
                      attrs: {
                        required: _vm.isRequired("ldrq"),
                        name: "ldrq",
                        label: "离店日期",
                        placeholder: "离店日期",
                        "input-align": "right",
                        rules: _vm.getRules("ldrq"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.ldrq,
                                    placeholder: "请选择离店日期",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.ldrq.show,
                                        index,
                                        "ldrq"
                                      )
                                    },
                                  },
                                }),
                                _c("van-calendar", {
                                  ref: "ldrq",
                                  refInFor: true,
                                  attrs: {
                                    "min-date": _vm.ccsj.minDate,
                                    "show-confirm": false,
                                    title: "选择离店日期",
                                  },
                                  on: {
                                    confirm: (date) => {
                                      _vm.ldrqConfirm(date, item, index)
                                    },
                                  },
                                  model: {
                                    value: _vm.ldrq.show[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ldrq.show, index, $$v)
                                    },
                                    expression: "ldrq.show[index]",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.ldrq,
                        callback: function ($$v) {
                          _vm.$set(item, "ldrq", $$v)
                        },
                        expression: "item.ldrq",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zsts",
                          expression: "'zsts'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("zsts"),
                        type: "number",
                        name: "zsts",
                        rules: _vm.getRules("zsts"),
                        required: _vm.isRequired("zsts"),
                        maxlength: 8,
                        placeholder: "请输入天数",
                        label: "天数",
                        "input-align": "right",
                      },
                      model: {
                        value: item.zsts,
                        callback: function ($$v) {
                          _vm.$set(item, "zsts", $$v)
                        },
                        expression: "item.zsts",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "bxje",
                          expression: "'bxje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("bxje"),
                        type: "number",
                        name: "bxje",
                        rules: _vm.getRules("bxje"),
                        required: _vm.isRequired("bxje"),
                        maxlength: 10,
                        placeholder: "请输入费用金额",
                        label: "费用金额",
                        "input-align": "right",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.formatToTwoDecimals(item, "bxje")
                        },
                      },
                      model: {
                        value: item.bxje,
                        callback: function ($$v) {
                          _vm.$set(item, "bxje", $$v)
                        },
                        expression: "item.bxje",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "fymx",
                          expression: "'fymx'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("fymx"),
                        type: "textarea",
                        name: "fymx",
                        rules: _vm.getRules("fymx"),
                        required: _vm.isRequired("fymx"),
                        maxlength: "200",
                        rows: "3",
                        autosize: "",
                        label: "费用说明",
                        "show-word-limit": "",
                        placeholder: "请输入费用说明",
                        "input-align": "right",
                      },
                      model: {
                        value: item.fymx,
                        callback: function ($$v) {
                          _vm.$set(item, "fymx", $$v)
                        },
                        expression: "item.fymx",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "gskm",
                          expression: "'gskm'",
                        },
                      ],
                      attrs: {
                        value: item.gskm,
                        "input-align": "right",
                        name: "gskm",
                        rules: _vm.getRules("gskm"),
                        required: _vm.isRequired("gskm"),
                        label: "归属科目",
                        placeholder: "请选择归属科目",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.gskm,
                                    placeholder: "请选择归属科目",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.gskm.show,
                                        index,
                                        "gskm"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.gskm.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.gskm.show, index, $$v)
                                      },
                                      expression: "gskm.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择归属科目",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.gskm.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.gskmSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`gskmTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.gskm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.gskm, "filterText", $$v)
                                        },
                                        expression: "gskm.filterText",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `gskmTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.gskm.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `gskmTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              _c(
                "van-cell-group",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "jdzsfhj",
                      expression: "'jdzsfhj'",
                    },
                  ],
                  staticClass: "m-t-20",
                },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "jdzsfhj",
                        expression: "'jdzsfhj'",
                      },
                    ],
                    attrs: {
                      center: "",
                      rules: _vm.getRules("jdzsfhj"),
                      required: _vm.isRequired("jdzsfhj"),
                      label: "住宿费合计",
                      "input-align": "right",
                      readonly: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("div", [
                              _vm.formData.jdzsfhj && _vm.formData.jdzsfhj != 0
                                ? _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.getFormatValue(
                                          _vm.formData.jdzsfhj
                                        ) + " 元"
                                      ),
                                    },
                                  })
                                : _c("span", [_vm._v("无")]),
                              _vm.formData.jdzsfhj && _vm.formData.jdzsfhj != 0
                                ? _c("div", [
                                    _c("span", { staticClass: "p-l-20" }, [
                                      _vm._v(" 大写："),
                                    ]),
                                    _c("span", { staticClass: "cor-F64646" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getChinese(_vm.formData.jdzsfhj)
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.formData.jdzsfhj,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "jdzsfhj", $$v)
                      },
                      expression: "formData.jdzsfhj",
                    },
                  }),
                ],
                1
              ),
              !_vm.isDisabled("jdzsfymxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加费用明细",
                            },
                            on: { click: _vm.addJdItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "cjjtfymxb",
                  expression: "'cjjtfymxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("城际交通费用")]
              ),
              _vm._l(_vm.formData.cjjtfymxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`城际交通费用明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("cjjtfymxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(
                                          index,
                                          "cjjtfymxb"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "xch",
                          expression: "'xch'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("xch"),
                        name: "xch",
                        rules: _vm.getRules("xch"),
                        required: _vm.isRequired("xch"),
                        maxlength: 50,
                        placeholder: "请输入行程号",
                        label: "行程号",
                        "input-align": "right",
                      },
                      model: {
                        value: item.xch,
                        callback: function ($$v) {
                          _vm.$set(item, "xch", $$v)
                        },
                        expression: "item.xch",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "cfsj",
                          expression: "'cfsj'",
                        },
                      ],
                      attrs: {
                        required: _vm.isRequired("cfsj"),
                        name: "cfsj",
                        label: "出发时间",
                        placeholder: "出发时间",
                        "input-align": "right",
                        rules: _vm.getRules("cfsj"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.cfsj,
                                    placeholder: "请选择出发时间",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.cfsj.show,
                                        index,
                                        "cfsj"
                                      )
                                    },
                                  },
                                }),
                                _c("van-calendar", {
                                  ref: "cfsj",
                                  refInFor: true,
                                  attrs: {
                                    "min-date": _vm.ccsj.minDate,
                                    "show-confirm": false,
                                    title: "选择出发时间",
                                  },
                                  on: {
                                    confirm: (date) => {
                                      _vm.cfsjConfirm(date, item, index)
                                    },
                                  },
                                  model: {
                                    value: _vm.cfsj.show[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.cfsj.show, index, $$v)
                                    },
                                    expression: "cfsj.show[index]",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.cfsj,
                        callback: function ($$v) {
                          _vm.$set(item, "cfsj", $$v)
                        },
                        expression: "item.cfsj",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "cfcs",
                          expression: "'cfcs'",
                        },
                      ],
                      attrs: {
                        name: "cfcs",
                        required: _vm.isRequired("cfcs"),
                        rules: _vm.getRules("cfcs"),
                        label: "出发城市",
                        placeholder: "出发城市",
                        "input-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.cfcs,
                                    placeholder: "请选择出发城市",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.cfcs.show,
                                        index,
                                        "cfcs"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.cfcs.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.cfcs.show, index, $$v)
                                      },
                                      expression: "cfcs.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择出发城市",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.cfcs.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.cfcsPopupSubmit(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`cfcsTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.cfcs.filterText[index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.cfcs.filterText,
                                            index,
                                            $$v
                                          )
                                        },
                                        expression: "cfcs.filterText[index]",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `cfcsTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.cfcs.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `cfcsTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.cfcs,
                        callback: function ($$v) {
                          _vm.$set(item, "cfcs", $$v)
                        },
                        expression: "item.cfcs",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "ddcs",
                          expression: "'ddcs'",
                        },
                      ],
                      attrs: {
                        name: "ddcs",
                        required: _vm.isRequired("ddcs"),
                        rules: _vm.getRules("ddcs"),
                        label: "到达城市",
                        placeholder: "到达城市",
                        "input-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.ddcs,
                                    placeholder: "请选择到达城市",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.ddcs.show,
                                        index,
                                        "ddcs"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.ddcs.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ddcs.show, index, $$v)
                                      },
                                      expression: "ddcs.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择到达城市",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.ddcs.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.ddcsPopupSubmit(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`ddcsTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.ddcs.filterText[index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ddcs.filterText,
                                            index,
                                            $$v
                                          )
                                        },
                                        expression: "ddcs.filterText[index]",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `ddcsTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.ddcs.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `ddcsTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.ddcs,
                        callback: function ($$v) {
                          _vm.$set(item, "ddcs", $$v)
                        },
                        expression: "item.ddcs",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "jtgj",
                          expression: "'jtgj'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "jtgj",
                        rules: _vm.getRules("jtgj"),
                        required: _vm.isRequired("jtgj"),
                        value: item.jtgj,
                        label: "交通工具",
                        placeholder: "请选择交通工具",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.jtgj,
                                    placeholder: "请选择交通工具",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.jtgj.show,
                                        index,
                                        "jtgj"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.jtgj.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.jtgj.show, index, $$v)
                                      },
                                      expression: "jtgj.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择交通工具",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.jtgj.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.jtgjSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.jtgj
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.jtgj.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.jtgj, "filterText", $$v)
                                        },
                                        expression: "jtgj.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `jtgjPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.jtgj.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.jtgj.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "jtlksj",
                          expression: "'jtlksj'",
                        },
                      ],
                      attrs: {
                        required: _vm.isRequired("jtlksj"),
                        name: "jtlksj",
                        label: "离开时间",
                        placeholder: "离开时间",
                        "input-align": "right",
                        rules: _vm.getRules("jtlksj"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.jtlksj,
                                    placeholder: "请选择离开时间",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.jtlksj.show,
                                        index,
                                        "jtlksj"
                                      )
                                    },
                                  },
                                }),
                                _c("van-calendar", {
                                  ref: "jtlksj",
                                  refInFor: true,
                                  attrs: {
                                    "min-date": _vm.ccsj.minDate,
                                    "show-confirm": false,
                                    title: "选择离开时间",
                                  },
                                  on: {
                                    confirm: (date) => {
                                      _vm.jtlksjConfirm(date, item, index)
                                    },
                                  },
                                  model: {
                                    value: _vm.jtlksj.show[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.jtlksj.show, index, $$v)
                                    },
                                    expression: "jtlksj.show[index]",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.jtlksj,
                        callback: function ($$v) {
                          _vm.$set(item, "jtlksj", $$v)
                        },
                        expression: "item.jtlksj",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "jtfyje",
                          expression: "'jtfyje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("jtfyje"),
                        type: "number",
                        name: "jtfyje",
                        rules: _vm.getRules("jtfyje"),
                        required: _vm.isRequired("jtfyje"),
                        maxlength: 10,
                        placeholder: "请输入费用金额",
                        label: "费用金额",
                        "input-align": "right",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.formatToTwoDecimals(item, "jtfyje")
                        },
                      },
                      model: {
                        value: item.jtfyje,
                        callback: function ($$v) {
                          _vm.$set(item, "jtfyje", $$v)
                        },
                        expression: "item.jtfyje",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "jtfysm",
                          expression: "'jtfysm'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("jtfysm"),
                        type: "textarea",
                        name: "jtfysm",
                        rules: _vm.getRules("jtfysm"),
                        required: _vm.isRequired("jtfysm"),
                        maxlength: "200",
                        rows: "3",
                        autosize: "",
                        label: "费用说明",
                        "show-word-limit": "",
                        placeholder: "请输入费用说明",
                        "input-align": "right",
                      },
                      model: {
                        value: item.jtfysm,
                        callback: function ($$v) {
                          _vm.$set(item, "jtfysm", $$v)
                        },
                        expression: "item.jtfysm",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "jtfygskm",
                          expression: "'jtfygskm'",
                        },
                      ],
                      attrs: {
                        value: item.jtfygskm,
                        "input-align": "right",
                        name: "jtfygskm",
                        rules: _vm.getRules("jtfygskm"),
                        required: _vm.isRequired("jtfygskm"),
                        label: "归属科目",
                        placeholder: "请选择归属科目",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.jtfygskm,
                                    placeholder: "请选择归属科目",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.jtfygskm.show,
                                        index,
                                        "jtfygskm"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.jtfygskm.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.jtfygskm.show, index, $$v)
                                      },
                                      expression: "jtfygskm.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择归属科目",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.jtfygskm.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.jtfygskmSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`jtfygskmTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.jtfygskm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.jtfygskm,
                                            "filterText",
                                            $$v
                                          )
                                        },
                                        expression: "jtfygskm.filterText",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `jtfygskmTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.jtfygskm.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `jtfygskmTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              _c(
                "van-cell-group",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "cjjtfhj",
                      expression: "'cjjtfhj'",
                    },
                  ],
                  staticClass: "m-t-20",
                },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "cjjtfhj",
                        expression: "'cjjtfhj'",
                      },
                    ],
                    attrs: {
                      center: "",
                      rules: _vm.getRules("cjjtfhj"),
                      required: _vm.isRequired("cjjtfhj"),
                      label: "交通费用合计",
                      "input-align": "right",
                      readonly: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("div", [
                              _vm.formData.cjjtfhj && _vm.formData.cjjtfhj != 0
                                ? _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.getFormatValue(
                                          _vm.formData.cjjtfhj
                                        ) + " 元"
                                      ),
                                    },
                                  })
                                : _c("span", [_vm._v("无")]),
                              _vm.formData.cjjtfhj && _vm.formData.cjjtfhj != 0
                                ? _c("div", [
                                    _c("span", { staticClass: "p-l-20" }, [
                                      _vm._v(" 大写："),
                                    ]),
                                    _c("span", { staticClass: "cor-F64646" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getChinese(_vm.formData.cjjtfhj)
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.formData.cjjtfhj,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "cjjtfhj", $$v)
                      },
                      expression: "formData.cjjtfhj",
                    },
                  }),
                ],
                1
              ),
              !_vm.isDisabled("cjjtfymxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加费用明细",
                            },
                            on: { click: _vm.addcjjtItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "qtfymxb",
                  expression: "'qtfymxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("其他费用")]
              ),
              _vm._l(_vm.formData.qtfymxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`其他费用明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("qtfymxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(index, "qtfymxb")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "qtfylx",
                          expression: "'qtfylx'",
                        },
                      ],
                      attrs: {
                        name: "qtfylx",
                        required: _vm.isRequired("qtfylx"),
                        rules: _vm.getRules("qtfylx"),
                        label: "费用类型",
                        placeholder: "费用类型",
                        "input-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.qtfylx,
                                    placeholder: "请选择费用类型",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.qtfylx.show,
                                        index,
                                        "qtfylx"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.qtfylx.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.qtfylx.show, index, $$v)
                                      },
                                      expression: "qtfylx.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择费用类型",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.qtfylx.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.qtfylxPopupSubmit(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`qtfylxTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.qtfylx.filterText[index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.qtfylx.filterText,
                                            index,
                                            $$v
                                          )
                                        },
                                        expression: "qtfylx.filterText[index]",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `qtfylxTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.qtfylx.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `qtfylxTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.qtfylx,
                        callback: function ($$v) {
                          _vm.$set(item, "qtfylx", $$v)
                        },
                        expression: "item.qtfylx",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "qtfyje",
                          expression: "'qtfyje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("qtfyje"),
                        type: "number",
                        name: "qtfyje",
                        rules: _vm.getRules("qtfyje"),
                        required: _vm.isRequired("qtfyje"),
                        maxlength: 10,
                        placeholder: "请输入费用金额",
                        label: "费用金额",
                        "input-align": "right",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.formatToTwoDecimals(item, "qtfyje")
                        },
                      },
                      model: {
                        value: item.qtfyje,
                        callback: function ($$v) {
                          _vm.$set(item, "qtfyje", $$v)
                        },
                        expression: "item.qtfyje",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "qtfymx",
                          expression: "'qtfymx'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("qtfymx"),
                        type: "textarea",
                        name: "qtfymx",
                        rules: _vm.getRules("qtfymx"),
                        required: _vm.isRequired("qtfymx"),
                        maxlength: "200",
                        rows: "3",
                        autosize: "",
                        label: "费用说明",
                        "show-word-limit": "",
                        placeholder: "请输入费用明细",
                        "input-align": "right",
                      },
                      model: {
                        value: item.qtfymx,
                        callback: function ($$v) {
                          _vm.$set(item, "qtfymx", $$v)
                        },
                        expression: "item.qtfymx",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "qtgskm",
                          expression: "'qtgskm'",
                        },
                      ],
                      attrs: {
                        value: item.qtgskm,
                        "input-align": "right",
                        name: "qtgskm",
                        rules: _vm.getRules("qtgskm"),
                        required: _vm.isRequired("qtgskm"),
                        label: "归属科目",
                        placeholder: "请选择归属科目",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.qtgskm,
                                    placeholder: "请选择归属科目",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.qtgskm.show,
                                        index,
                                        "qtgskm"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.qtgskm.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.qtgskm.show, index, $$v)
                                      },
                                      expression: "qtgskm.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择归属科目",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.qtgskm.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.qtgskmSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`qtgskmTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.qtgskm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.qtgskm,
                                            "filterText",
                                            $$v
                                          )
                                        },
                                        expression: "qtgskm.filterText",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `qtgskmTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.qtgskm.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `qtgskmTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              _c(
                "van-cell-group",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "qtfyhj",
                      expression: "'qtfyhj'",
                    },
                  ],
                  staticClass: "m-t-20",
                },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "qtfyhj",
                        expression: "'qtfyhj'",
                      },
                    ],
                    attrs: {
                      center: "",
                      rules: _vm.getRules("qtfyhj"),
                      required: _vm.isRequired("qtfyhj"),
                      label: "其他费用合计",
                      "input-align": "right",
                      readonly: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("div", [
                              _vm.formData.qtfyhj && _vm.formData.qtfyhj != 0
                                ? _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.getFormatValue(
                                          _vm.formData.qtfyhj
                                        ) + " 元"
                                      ),
                                    },
                                  })
                                : _c("span", [_vm._v("无")]),
                              _vm.formData.qtfyhj && _vm.formData.qtfyhj != 0
                                ? _c("div", [
                                    _c("span", { staticClass: "p-l-20" }, [
                                      _vm._v(" 大写："),
                                    ]),
                                    _c("span", { staticClass: "cor-F64646" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getChinese(_vm.formData.qtfyhj)
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.formData.qtfyhj,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "qtfyhj", $$v)
                      },
                      expression: "formData.qtfyhj",
                    },
                  }),
                ],
                1
              ),
              !_vm.isDisabled("qtfymxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加费用明细",
                            },
                            on: { click: _vm.addQtfyItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "clbzmxb",
                  expression: "'clbzmxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("差旅补助")]
              ),
              _vm._l(_vm.formData.clbzmxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`差旅补助明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("clbzmxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(index, "clbzmxb")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "ccsj",
                          expression: "'ccsj'",
                        },
                      ],
                      attrs: {
                        value: item.ccsj[0],
                        required: _vm.isRequired("ccsj"),
                        name: "ccsj",
                        label: "出差时间",
                        placeholder: "出差时间",
                        "input-align": "right",
                        rules: _vm.getRules("ccsj"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _vm.isDisabled("ccsj")
                                  ? _c("view-item", {
                                      attrs: {
                                        value:
                                          item.ccsj.length > 1
                                            ? `${item.ccsj[0]} - ${item.ccsj[1]}`
                                            : "",
                                        placeholder: "请选择出差时间",
                                      },
                                    })
                                  : _c("view-item", {
                                      attrs: {
                                        value:
                                          item.ccsj.length > 1
                                            ? `${item.ccsj[0]} - ${item.ccsj[1]}`
                                            : "",
                                        placeholder: "请选择出差时间",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.popupShow(
                                            _vm.ccsj.show,
                                            index,
                                            "ccsj"
                                          )
                                        },
                                      },
                                    }),
                                _c("van-calendar", {
                                  ref: "ccsj",
                                  refInFor: true,
                                  attrs: {
                                    "min-date": _vm.ccsj.minDate,
                                    "allow-same-day": "",
                                    type: "range",
                                    "show-confirm": false,
                                    title: "选择出差时间",
                                  },
                                  on: {
                                    confirm: (date) => {
                                      _vm.ccsjConfirm(date, item, index)
                                    },
                                  },
                                  model: {
                                    value: _vm.ccsj.show[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ccsj.show, index, $$v)
                                    },
                                    expression: "ccsj.show[index]",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "cbts",
                          expression: "'cbts'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("cbts"),
                        type: "number",
                        name: "cbts",
                        rules: _vm.getRules("cbts"),
                        required: _vm.isRequired("cbts"),
                        maxlength: 8,
                        placeholder: "请输入差补天数",
                        label: "差补天数",
                        "input-align": "right",
                      },
                      model: {
                        value: item.cbts,
                        callback: function ($$v) {
                          _vm.$set(item, "cbts", $$v)
                        },
                        expression: "item.cbts",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "cbbz",
                          expression: "'cbbz'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("cbbz"),
                        type: "number",
                        name: "cbbz",
                        rules: _vm.getRules("cbbz"),
                        required: _vm.isRequired("cbbz"),
                        maxlength: 8,
                        placeholder: "请输入差补标准",
                        label: "差补标准",
                        "input-align": "right",
                      },
                      on: {
                        input: (value) => {
                          _vm.cbbzFieldInput(value, item, index)
                        },
                      },
                      model: {
                        value: item.cbbz,
                        callback: function ($$v) {
                          _vm.$set(item, "cbbz", $$v)
                        },
                        expression: "item.cbbz",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "cbje",
                          expression: "'cbje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("cbje"),
                        type: "number",
                        name: "cbje",
                        rules: _vm.getRules("cbje"),
                        required: _vm.isRequired("cbje"),
                        maxlength: 10,
                        placeholder: "请输入差补金额",
                        label: "差补金额",
                        "input-align": "right",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.formatToTwoDecimals(item, "cbje")
                        },
                      },
                      model: {
                        value: item.cbje,
                        callback: function ($$v) {
                          _vm.$set(item, "cbje", $$v)
                        },
                        expression: "item.cbje",
                      },
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "clgskm",
                          expression: "'clgskm'",
                        },
                      ],
                      attrs: {
                        value: item.clgskm,
                        "input-align": "right",
                        name: "clgskm",
                        rules: _vm.getRules("clgskm"),
                        required: _vm.isRequired("clgskm"),
                        label: "归属科目",
                        placeholder: "请选择归属科目",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.clgskm,
                                    placeholder: "请选择归属科目",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.clgskm.show,
                                        index,
                                        "clgskm"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.clgskm.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.clgskm.show, index, $$v)
                                      },
                                      expression: "clgskm.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择归属科目",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.clgskm.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.clgskmSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.treeSearch(
                                            $event,
                                            _vm.$refs[`clgskmTree_${index}`]
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.clgskm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.clgskm,
                                            "filterText",
                                            $$v
                                          )
                                        },
                                        expression: "clgskm.filterText",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "h-vh-35",
                                        staticStyle: { "overflow-y": "auto" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "p-10" },
                                          [
                                            _c("el-tree", {
                                              ref: `clgskmTree_${index}`,
                                              refInFor: true,
                                              attrs: {
                                                "node-key": "id",
                                                "check-strictly": "",
                                                data: _vm.clgskm.data,
                                                "filter-node-method":
                                                  _vm.filterNode,
                                                "check-on-click-node": "",
                                                "show-checkbox": "",
                                              },
                                              on: {
                                                "check-change": function (
                                                  $event
                                                ) {
                                                  return _vm.singleChoice(
                                                    $event,
                                                    _vm.$refs[
                                                      `clgskmTree_${index}`
                                                    ],
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
              _c(
                "van-cell-group",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "clbzhj",
                      expression: "'clbzhj'",
                    },
                  ],
                  staticClass: "m-t-20",
                },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "clbzhj",
                        expression: "'clbzhj'",
                      },
                    ],
                    attrs: {
                      center: "",
                      rules: _vm.getRules("clbzhj"),
                      required: _vm.isRequired("clbzhj"),
                      label: "差旅补助合计",
                      "input-align": "right",
                      readonly: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("div", [
                              _vm.formData.clbzhj && _vm.formData.clbzhj != 0
                                ? _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.getFormatValue(
                                          _vm.formData.clbzhj
                                        ) + " 元"
                                      ),
                                    },
                                  })
                                : _c("span", [_vm._v("无")]),
                              _vm.formData.clbzhj && _vm.formData.clbzhj != 0
                                ? _c("div", [
                                    _c("span", { staticClass: "p-l-20" }, [
                                      _vm._v(" 大写："),
                                    ]),
                                    _c("span", { staticClass: "cor-F64646" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getChinese(_vm.formData.clbzhj)
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.formData.clbzhj,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "clbzhj", $$v)
                      },
                      expression: "formData.clbzhj",
                    },
                  }),
                ],
                1
              ),
              !_vm.isDisabled("clbzmxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加差补明细",
                            },
                            on: { click: _vm.addClbzItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "bxzje",
                  expression: "'bxzje'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("差旅费用合计")]
              ),
              _c(
                "van-cell-group",
                { staticClass: "b-r-10 m-t-20" },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "bxzje",
                        expression: "'bxzje'",
                      },
                    ],
                    attrs: {
                      center: "",
                      rules: _vm.getRules("bxzje"),
                      required: _vm.isRequired("bxzje"),
                      label: "差旅费用合计",
                      "input-align": "right",
                      readonly: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("div", [
                              _vm.formData.bxzje && _vm.formData.bxzje != 0
                                ? _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.getFormatValue(_vm.formData.bxzje) +
                                          " 元"
                                      ),
                                    },
                                  })
                                : _c("span", [_vm._v("无")]),
                              _vm.formData.bxzje && _vm.formData.bxzje != 0
                                ? _c("div", [
                                    _c("span", { staticClass: "p-l-20" }, [
                                      _vm._v("大写："),
                                    ]),
                                    _c("span", { staticClass: "cor-F64646" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getChinese(_vm.formData.bxzje)
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.formData.bxzje,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "bxzje", $$v)
                      },
                      expression: "formData.bxzje",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
            [_vm._v("借款冲销")]
          ),
          _c(
            "van-cell-group",
            { staticClass: "m-t-10" },
            [
              _c(
                "van-field",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "bxfs",
                      expression: "'bxfs'",
                    },
                  ],
                  attrs: {
                    center: "",
                    "input-align": "right",
                    required: _vm.isRequired("bxfs"),
                    name: "bxfs",
                    rules: _vm.getRules("bxfs"),
                    label: "报销方式",
                    placeholder: "请选择报销方式",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "input",
                      fn: function () {
                        return [
                          _vm.isDisabled("bxfs")
                            ? _c("view-item", {
                                attrs: {
                                  value:
                                    _vm.formData.bxfs == "0"
                                      ? "正常报销"
                                      : _vm.formData.bxfs == "1"
                                      ? "借款冲销"
                                      : "供应商货款冲销",
                                  placeholder: "请选择申请人",
                                },
                              })
                            : _c(
                                "van-radio-group",
                                {
                                  attrs: { direction: "horizontal" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeBxfs()
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.bxfs,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "bxfs", $$v)
                                    },
                                    expression: "formData.bxfs",
                                  },
                                },
                                [
                                  _c(
                                    "van-radio",
                                    {
                                      staticClass: "m-r-20",
                                      attrs: { name: "0" },
                                    },
                                    [_vm._v("正常报销")]
                                  ),
                                  _c(
                                    "van-radio",
                                    {
                                      staticClass: "m-r-20",
                                      attrs: { name: "1" },
                                    },
                                    [_vm._v("借款冲销")]
                                  ),
                                ],
                                1
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.formData.bxfs,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "bxfs", $$v)
                    },
                    expression: "formData.bxfs",
                  },
                },
                [_vm._v("~ ")]
              ),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxfs",
                    expression: "'bxfs'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("debtMoney"),
                  label: "累计借款欠款",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.debtMoney && _vm.formData.debtMoney != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.debtMoney) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.debtMoney && _vm.formData.debtMoney != 0
                            ? _c("span", { staticClass: "p-l-20" }, [
                                _vm._v(" 大写："),
                              ])
                            : _vm._e(),
                          _vm.formData.debtMoney && _vm.formData.debtMoney != 0
                            ? _c("span", { staticClass: "cor-F64646" }, [
                                _vm._v(
                                  _vm._s(_vm.getChinese(_vm.formData.debtMoney))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.debtMoney,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "debtMoney", $$v)
                  },
                  expression: "formData.debtMoney",
                },
              }),
            ],
            1
          ),
          _vm.formData.bxfs == "1"
            ? _c(
                "div",
                [
                  _vm._l(_vm.formData.byjmxb, function (item, index) {
                    return _c(
                      "van-cell-group",
                      { key: index, staticClass: "b-r-10 m-t-20" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "p-b-20",
                            staticStyle: {
                              "border-bottom": "1px solid #EBEBEB",
                            },
                          },
                          [
                            _c(
                              "van-row",
                              { attrs: { type: "flex", align: "center" } },
                              [
                                _c("van-col", { attrs: { span: 22 } }, [
                                  _c("img", {
                                    staticClass: "w-5 h-28",
                                    attrs: {
                                      src: `${_vm.image_base_url}/icon_line.png`,
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cor-33 font-weight-500 font-28 m-l-16",
                                    },
                                    [_vm._v(_vm._s(`借款明细${index + 1}`))]
                                  ),
                                ]),
                                _vm.isShowIcon("byjmxb")
                                  ? _c(
                                      "van-col",
                                      {
                                        attrs: { span: 2 },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(
                                              index,
                                              "byjmxb"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "w-30 h-30",
                                          attrs: {
                                            src: `${_vm.image_base_url}/shoppingDel.png`,
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "userName",
                              expression: "'userName'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("userName"),
                            rules: _vm.getRules("userName"),
                            label: "借款人",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.userName,
                            callback: function ($$v) {
                              _vm.$set(item, "userName", $$v)
                            },
                            expression: "item.userName",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "businessNo",
                              expression: "'businessNo'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("businessNo"),
                            rules: _vm.getRules("businessNo"),
                            label: "关联单号",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.businessNo,
                            callback: function ($$v) {
                              _vm.$set(item, "businessNo", $$v)
                            },
                            expression: "item.businessNo",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "debtTime",
                              expression: "'debtTime'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("debtTime"),
                            rules: _vm.getRules("debtTime"),
                            label: "借款时间",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .moment(item.debtTime)
                                            .format("YYYY-MM-DD hh:mm:ss")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.debtTime,
                            callback: function ($$v) {
                              _vm.$set(item, "debtTime", $$v)
                            },
                            expression: "item.debtTime",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "debtAmount",
                              expression: "'debtAmount'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("debtAmount"),
                            rules: _vm.getRules("debtAmount"),
                            label: "借款金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.formatToTwoDecimals(item, "debtAmount")
                            },
                          },
                          model: {
                            value: item.debtAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "debtAmount", $$v)
                            },
                            expression: "item.debtAmount",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "repayAmount",
                              expression: "'repayAmount'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("repayAmount"),
                            rules: _vm.getRules("repayAmount"),
                            label: "已还款金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.formatToTwoDecimals(
                                item,
                                "repayAmount"
                              )
                            },
                          },
                          model: {
                            value: item.repayAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "repayAmount", $$v)
                            },
                            expression: "item.repayAmount",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "currentRepayAmount",
                              expression: "'currentRepayAmount'",
                            },
                          ],
                          attrs: {
                            disabled: _vm.isDisabled("currentRepayAmount"),
                            type: "number",
                            name: "currentRepayAmount",
                            rules: _vm.getRules("currentRepayAmount"),
                            required: _vm.isRequired("currentRepayAmount"),
                            maxlength: 10,
                            placeholder: "请输入本次冲销金额",
                            label: "本次冲销金额",
                            "input-align": "right",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.formatToTwoDecimals(
                                item,
                                "currentRepayAmount"
                              )
                            },
                          },
                          model: {
                            value: item.currentRepayAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "currentRepayAmount", $$v)
                            },
                            expression: "item.currentRepayAmount",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  !_vm.isDisabled("byjmxb")
                    ? _c(
                        "van-row",
                        [
                          _c("van-col", { attrs: { span: 12 } }),
                          _c(
                            "van-col",
                            { attrs: { span: 12 } },
                            [
                              _c("van-button", {
                                staticClass: "width-100",
                                attrs: {
                                  icon: "add-o",
                                  round: "",
                                  "native-type": "button",
                                  color: "#FFDA3E",
                                  text: "添加借款",
                                },
                                on: { click: _vm.addImprest },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "van-cell-group",
                    {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "currentRepayAmountTotal",
                          expression: "'currentRepayAmountTotal'",
                        },
                      ],
                      staticClass: "m-t-20",
                    },
                    [
                      _c("van-field", {
                        directives: [
                          {
                            name: "f-show",
                            rawName: "v-f-show",
                            value: "currentRepayAmountTotal",
                            expression: "'currentRepayAmountTotal'",
                          },
                        ],
                        attrs: {
                          center: "",
                          rules: _vm.getRules("currentRepayAmountTotal"),
                          required: _vm.isRequired("currentRepayAmountTotal"),
                          label: "本次冲销总金额",
                          "input-align": "right",
                          readonly: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm.formData.currentRepayAmountTotal &&
                                    _vm.formData.currentRepayAmountTotal != 0
                                      ? _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.getFormatValue(
                                                _vm.formData
                                                  .currentRepayAmountTotal
                                              ) + " 元"
                                            ),
                                          },
                                        })
                                      : _c("span", [_vm._v("无")]),
                                    _vm.formData.currentRepayAmountTotal &&
                                    _vm.formData.currentRepayAmountTotal != 0
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "p-l-20" },
                                            [_vm._v(" 大写：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "cor-F64646" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getChinese(
                                                    _vm.formData
                                                      .currentRepayAmountTotal
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          970224172
                        ),
                        model: {
                          value: _vm.formData.currentRepayAmountTotal,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "currentRepayAmountTotal",
                              $$v
                            )
                          },
                          expression: "formData.currentRepayAmountTotal",
                        },
                      }),
                      _c("van-field", {
                        directives: [
                          {
                            name: "f-show",
                            rawName: "v-f-show",
                            value: "payCashTotal",
                            expression: "'payCashTotal'",
                          },
                        ],
                        attrs: {
                          center: "",
                          rules: _vm.getRules("payCashTotal"),
                          required: _vm.isRequired("payCashTotal"),
                          label: "本次现金还款总金额",
                          "input-align": "right",
                          readonly: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm.formData.payCashTotal &&
                                    _vm.formData.payCashTotal != 0
                                      ? _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.getFormatValue(
                                                _vm.formData.payCashTotal
                                              ) + " 元"
                                            ),
                                          },
                                        })
                                      : _c("span", [_vm._v("无")]),
                                    _vm.formData.payCashTotal &&
                                    _vm.formData.payCashTotal != 0
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "p-l-20" },
                                            [_vm._v(" 大写：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "cor-F64646" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getChinese(
                                                    _vm.formData.payCashTotal
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3759350380
                        ),
                        model: {
                          value: _vm.formData.payCashTotal,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "payCashTotal", $$v)
                          },
                          expression: "formData.payCashTotal",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "flex row-between col-center m-t-20" },
                [
                  _c("div", { staticClass: "font-32 font-weight-500 cor-00" }, [
                    _vm._v("收款人账户信息"),
                  ]),
                  _c(
                    "van-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.isDisabled("skryhzh"),
                        "native-type": "button",
                      },
                      on: {
                        click: function ($event) {
                          _vm.account.show = true
                        },
                      },
                    },
                    [_vm._v("选择收款人账户 ")]
                  ),
                ],
                1
              ),
              _c(
                "van-cell-group",
                { staticClass: "m-t-20" },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "skrhm",
                        expression: "'skrhm'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("skrhm"),
                      required: _vm.isRequired("skrhm"),
                      name: "skrhm",
                      rules: _vm.getRules("skrhm"),
                      maxlength: "50",
                      autosize: "",
                      label: "收款人户名",
                      placeholder: "请输入收款人户名",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.skrhm,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skrhm", $$v)
                      },
                      expression: "formData.skrhm",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "skrkhh",
                        expression: "'skrkhh'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("skrkhh"),
                      required: _vm.isRequired("skrkhh"),
                      rules: _vm.getRules("skrkhh"),
                      name: "skrkhh",
                      maxlength: "50",
                      autosize: "",
                      label: "收款人开户行",
                      placeholder: "请输入收款人开户行",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.skrkhh,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skrkhh", $$v)
                      },
                      expression: "formData.skrkhh",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "skryhzh",
                        expression: "'skryhzh'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("skryhzh"),
                      required: _vm.isRequired("skryhzh"),
                      rules: _vm.getRules("skryhzh"),
                      name: "skryhzh",
                      maxlength: "50",
                      autosize: "",
                      label: "收款人账号",
                      placeholder: "请输入收款人账号",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.skryhzh,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skryhzh", $$v)
                      },
                      expression: "formData.skryhzh",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "zffsmxb",
                  expression: "'zffsmxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("财务出款")]
              ),
              _vm._l(_vm.formData.zffsmxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("zffsmxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(index, "zffsmxb")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "fkzh",
                          expression: "'fkzh'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "fkzh",
                        rules: _vm.getRules("fkzh"),
                        required: _vm.isRequired("fkzh"),
                        value: item.fkzh,
                        label: "付款账户",
                        placeholder: "请选择付款账户",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.fkzh,
                                    placeholder: "请选择付款账户",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.fkzh.show,
                                        index,
                                        "fkzh"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.fkzh.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.fkzh.show, index, $$v)
                                      },
                                      expression: "fkzh.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择付款账户",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.fkzh.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.fkzhSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.fkzh,
                                            "name"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fkzh.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.fkzh, "filterText", $$v)
                                        },
                                        expression: "fkzh.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `fkzhPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.fkzh.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.fkzh.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zffs",
                          expression: "'zffs'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "zffs",
                        rules: _vm.getRules("zffs"),
                        required: _vm.isRequired("zffs"),
                        value: item.zffs,
                        label: "支付方式",
                        placeholder: "请选择支付方式",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.zffs,
                                    placeholder: "请选择支付方式",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.zffs.show,
                                        index,
                                        "zffs"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.zffs.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.zffs.show, index, $$v)
                                      },
                                      expression: "zffs.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择支付方式",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.zffs.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.zffsSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.zffs,
                                            "name"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.zffs.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.zffs, "filterText", $$v)
                                        },
                                        expression: "zffs.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `zffsPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.zffs.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.zffs.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zfmxje",
                          expression: "'zfmxje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("zfmxje"),
                        type: "number",
                        name: "zfmxje",
                        rules: _vm.getRules("zfmxje"),
                        required: _vm.isRequired("zfmxje"),
                        maxlength: 10,
                        placeholder: "请输入支付金额",
                        label: "支付金额",
                        "input-align": "right",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.formatToTwoDecimals(item, "zfmxje")
                        },
                        change: function ($event) {
                          return _vm.changeZffsmxb(item)
                        },
                      },
                      model: {
                        value: item.zfmxje,
                        callback: function ($$v) {
                          _vm.$set(item, "zfmxje", $$v)
                        },
                        expression: "item.zfmxje",
                      },
                    }),
                  ],
                  1
                )
              }),
              !_vm.isDisabled("zffsmxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加出款明细",
                            },
                            on: { click: _vm.addFKItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sfygz",
                    expression: "'sfygz'",
                  },
                ],
                attrs: {
                  center: "",
                  "input-align": "right",
                  required: _vm.isRequired("sfygz"),
                  name: "sfygz",
                  rules: _vm.getRules("sfygz"),
                  label: "是否有挂账",
                  placeholder: "是否有挂账",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("sfygz")
                          ? _c("view-item", {
                              attrs: { value: _vm.formData.sfygz },
                            })
                          : _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeSfgzbx()
                                  },
                                },
                                model: {
                                  value: _vm.formData.sfygz,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sfygz", $$v)
                                  },
                                  expression: "formData.sfygz",
                                },
                              },
                              [
                                _c("van-radio", { attrs: { name: "无" } }, [
                                  _vm._v("无"),
                                ]),
                                _c("van-radio", { attrs: { name: "有" } }, [
                                  _vm._v("有"),
                                ]),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.sfygz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sfygz", $$v)
                  },
                  expression: "formData.sfygz",
                },
              }),
              _vm.formData.sfygz === "有"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "gzje",
                        expression: "'gzje'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("gzje"),
                      type: "number",
                      name: "gzje",
                      rules: _vm.getRules("gzje"),
                      required: _vm.isRequired("gzje"),
                      maxlength: 10,
                      placeholder: "请输入挂账金额",
                      label: "挂账金额",
                      "input-align": "right",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.formatToTwoDecimals(_vm.formData, "gzje")
                      },
                    },
                    model: {
                      value: _vm.formData.gzje,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "gzje", $$v)
                      },
                      expression: "formData.gzje",
                    },
                  })
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ckje",
                    expression: "'ckje'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("ckje"),
                  type: "number",
                  name: "ckje",
                  rules: _vm.getRules("ckje"),
                  required: _vm.isRequired("ckje"),
                  maxlength: 10,
                  placeholder: "请输入出款金额",
                  label: "出款金额",
                  "input-align": "right",
                },
                on: {
                  input: function ($event) {
                    return _vm.formatToTwoDecimals(_vm.formData, "ckje")
                  },
                },
                model: {
                  value: _vm.formData.ckje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ckje", $$v)
                  },
                  expression: "formData.ckje",
                },
              }),
            ],
            1
          ),
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "lkr",
                    expression: "'lkr'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("lkr"),
                  required: _vm.isRequired("lkr"),
                  name: "lkr",
                  rules: _vm.getRules("lkr"),
                  label: "领款人",
                  "show-word-limit": "",
                  placeholder: "请输入领款人",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.lkr,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lkr", $$v)
                  },
                  expression: "formData.lkr",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "lksj",
                    expression: "'lksj'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("lksj"),
                  name: "lksj",
                  label: "领款时间",
                  placeholder: "领款时间",
                  "input-align": "right",
                  rules: _vm.getRules("lksj"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.lksj,
                            placeholder: "请选择领款时间",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.lksj, "lksj")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "lksj",
                          attrs: {
                            "min-date": _vm.ccsj.minDate,
                            "show-confirm": false,
                            title: "选择领款时间",
                          },
                          on: { confirm: _vm.lksjConfirm },
                          model: {
                            value: _vm.lksj.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.lksj, "show", $$v)
                            },
                            expression: "lksj.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.lksj,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "lksj", $$v)
                  },
                  expression: "formData.lksj",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.fjUploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "papfj",
                    expression: "'papfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "papfj",
                  required: _vm.isRequired("papfj"),
                  rules: _vm.getRules("papfj"),
                  label: "纸质报销凭证",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.papfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("papfj"),
                            files: _vm.formData.papfj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadPapfjSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "papfj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "van-row",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "fpfj",
                  expression: "'fpfj'",
                },
              ],
              staticClass: "m-t-20",
              attrs: { type: "flex", align: "center" },
            },
            [
              _c("van-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "font-32 font-weight-500 cor-00" }, [
                  _vm._v("发票信息"),
                ]),
              ]),
              _c(
                "van-col",
                { attrs: { span: 12 } },
                [
                  !_vm.isDisabled("fpfj")
                    ? _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "上传并识别",
                        },
                        on: { click: _vm.uploadInvoice },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.formData.fpfj.length === 0
            ? _c("van-cell-group", { staticClass: "text-center m-t-20 p-20" }, [
                _c("img", {
                  staticClass: "w-300 h-300",
                  attrs: { src: `${_vm.image_base_url}/null.png` },
                }),
                _c("div", { staticClass: "font-24 cor-8B m-t-20" }, [
                  _vm._v("暂无发票信息~"),
                ]),
              ])
            : _vm._e(),
          _vm._l(_vm.formData.fpfj, function (item, index) {
            return _c(
              "van-cell-group",
              {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fpfj",
                    expression: "'fpfj'",
                  },
                ],
                key: index,
                staticClass: "b-r-10 m-t-20",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      { attrs: { type: "flex", align: "center" } },
                      [
                        _c("van-col", { attrs: { span: 22 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`明细${index + 1}`))]
                          ),
                        ]),
                        _vm.isShowIcon("fpfj")
                          ? _c(
                              "van-col",
                              {
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "fpfj")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                item.invoiceType == 3
                  ? _c(
                      "div",
                      [
                        _c("van-field", {
                          attrs: {
                            label: "发票抬头",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceTitle,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceTitle", $$v)
                            },
                            expression: "item.invoiceTitle",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "发票号码",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceCode", $$v)
                            },
                            expression: "item.invoiceCode",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "开票日期",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.invoiceDate) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.invoiceDate,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceDate", $$v)
                            },
                            expression: "item.invoiceDate",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.ticketPrice,
                            callback: function ($$v) {
                              _vm.$set(item, "ticketPrice", $$v)
                            },
                            expression: "item.ticketPrice",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "行程信息",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.travelInformation,
                            callback: function ($$v) {
                              _vm.$set(item, "travelInformation", $$v)
                            },
                            expression: "item.travelInformation",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "乘车时间",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.travelTime,
                            callback: function ($$v) {
                              _vm.$set(item, "travelTime", $$v)
                            },
                            expression: "item.travelTime",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "乘车人",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.passenger,
                            callback: function ($$v) {
                              _vm.$set(item, "passenger", $$v)
                            },
                            expression: "item.passenger",
                          },
                        }),
                      ],
                      1
                    )
                  : item.invoiceType == 4
                  ? _c(
                      "div",
                      [
                        _c("van-field", {
                          attrs: {
                            label: "发票抬头",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceTitle,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceTitle", $$v)
                            },
                            expression: "item.invoiceTitle",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "发票号码",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceCode", $$v)
                            },
                            expression: "item.invoiceCode",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "开票日期",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.invoiceDate) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.invoiceDate,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceDate", $$v)
                            },
                            expression: "item.invoiceDate",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "机票金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.ticketPrice,
                            callback: function ($$v) {
                              _vm.$set(item, "ticketPrice", $$v)
                            },
                            expression: "item.ticketPrice",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "燃油附加费",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.fuelFee,
                            callback: function ($$v) {
                              _vm.$set(item, "fuelFee", $$v)
                            },
                            expression: "item.fuelFee",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "民航发展基金",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.civilFund,
                            callback: function ($$v) {
                              _vm.$set(item, "civilFund", $$v)
                            },
                            expression: "item.civilFund",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "合计金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceAmount", $$v)
                            },
                            expression: "item.invoiceAmount",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "出发城市",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.departureStation,
                            callback: function ($$v) {
                              _vm.$set(item, "departureStation", $$v)
                            },
                            expression: "item.departureStation",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "到达城市",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.arriveStation,
                            callback: function ($$v) {
                              _vm.$set(item, "arriveStation", $$v)
                            },
                            expression: "item.arriveStation",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "乘机人",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.passenger,
                            callback: function ($$v) {
                              _vm.$set(item, "passenger", $$v)
                            },
                            expression: "item.passenger",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("van-field", {
                          attrs: {
                            label: "发票抬头",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceTitle,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceTitle", $$v)
                            },
                            expression: "item.invoiceTitle",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "发票号码",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceCode", $$v)
                            },
                            expression: "item.invoiceCode",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "开票日期",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.invoiceDate) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.invoiceDate,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceDate", $$v)
                            },
                            expression: "item.invoiceDate",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "税额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.taxAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "taxAmount", $$v)
                            },
                            expression: "item.taxAmount",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "不含税金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.taxExcludedAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "taxExcludedAmount", $$v)
                            },
                            expression: "item.taxExcludedAmount",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "价税合计金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceAmount", $$v)
                            },
                            expression: "item.invoiceAmount",
                          },
                        }),
                      ],
                      1
                    ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "fpfj",
                      expression: "'fpfj'",
                    },
                  ],
                  attrs: {
                    "input-align": "right",
                    name: "fpfj",
                    label: "附件",
                    placeholder: "请上传文件",
                  },
                  domProps: { value: item.file.filePath },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            item.file.filePath
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "pdfFormBox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.fpfjClick(item.file)
                                      },
                                    },
                                  },
                                  [
                                    _c("PdfPreview", {
                                      ref: "PdfPreview" + index,
                                      refInFor: true,
                                      attrs: { "pdf-url": item.file.filePath },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          }),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                attrs: {
                  center: "",
                  label: "发票金额合计",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.invoiceAmountTotal && _vm.invoiceAmountTotal != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.invoiceAmountTotal) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.invoiceAmountTotal && _vm.invoiceAmountTotal != 0
                            ? _c("div", [
                                _c("span", { staticClass: "p-l-20" }, [
                                  _vm._v(" 大写："),
                                ]),
                                _c("span", { staticClass: "cor-F64646" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getChinese(_vm.invoiceAmountTotal)
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.invoiceAmountTotal,
                  callback: function ($$v) {
                    _vm.invoiceAmountTotal = $$v
                  },
                  expression: "invoiceAmountTotal",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "elecTickets",
                    expression: "'elecTickets'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("elecTickets"),
                  type: "digit",
                  required: _vm.isRequired("elecTickets"),
                  rules: _vm.getRules("pjzselecTickets"),
                  name: "elecTickets",
                  maxlength: "50",
                  autosize: "",
                  label: "电子票据张数",
                  placeholder: "请输入电子票据张数",
                  "input-align": "right",
                },
                on: { blur: _vm.pjzsChange },
                model: {
                  value: _vm.formData.elecTickets,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "elecTickets", $$v)
                  },
                  expression: "formData.elecTickets",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "papTickets",
                    expression: "'papTickets'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("papTickets"),
                  type: "digit",
                  required: _vm.isRequired("papTickets"),
                  rules: _vm.getRules("papTickets"),
                  name: "papTickets",
                  maxlength: "50",
                  autosize: "",
                  label: "纸质票据张数",
                  placeholder: "请输入纸质票据张数",
                  "input-align": "right",
                },
                on: { blur: _vm.pjzsChange },
                model: {
                  value: _vm.formData.papTickets,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "papTickets", $$v)
                  },
                  expression: "formData.papTickets",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "pjzs",
                    expression: "'pjzs'",
                  },
                ],
                attrs: {
                  readonly: "",
                  type: "digit",
                  rules: _vm.getRules("pjzs"),
                  name: "pjzs",
                  maxlength: "50",
                  autosize: "",
                  label: "票据张数",
                  placeholder: "请输入票据张数",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.pjzs,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "pjzs", $$v)
                  },
                  expression: "formData.pjzs",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "relativeFlow",
                  expression: "'relativeFlow'",
                },
              ],
            },
            [
              _c(
                "van-row",
                {
                  staticClass: "m-t-26 m-b-26",
                  attrs: { type: "flex", align: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "font-32 font-weight-500 cor-00" },
                      [_vm._v("关联流程")]
                    ),
                  ]),
                  _vm.formData.relativeFlow.length <= 0
                    ? _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.isDisabled("relativeFlow")
                            ? _c("van-button", {
                                staticClass: "width-100",
                                attrs: {
                                  icon: "add-o",
                                  round: "",
                                  "native-type": "button",
                                  color: "#FFDA3E",
                                  text: "添加审批单",
                                },
                                on: { click: _vm.addSpd },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.formData.relativeFlow.length === 0
                ? _c("van-cell-group", { staticClass: "text-center p-20" }, [
                    _c("img", {
                      staticClass: "w-300 h-300",
                      attrs: { src: `${_vm.image_base_url}/null.png` },
                    }),
                    _c("div", { staticClass: "font-24 cor-8B m-t-20" }, [
                      _vm._v("暂无关联流程，请点击“添加审批单”关联~"),
                    ]),
                  ])
                : _vm._l(_vm.formData.relativeFlow, function (item, index) {
                    return _c(
                      "van-cell-group",
                      { key: index, staticClass: "b-r-10 m-t-20 p-20" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex col-center row-between" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isDisabled("relativeFlow"),
                                    expression: "!isDisabled('relativeFlow')",
                                  },
                                ],
                                staticClass:
                                  "font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "relativeFlow")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("流程状态"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.businessStatusName) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("申请时间"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.startTime
                                          ? _vm
                                              .moment(item.startTime)
                                              .format("YYYY-MM-DD")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("完成时间"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.endTime
                                          ? _vm
                                              .moment(item.endTime)
                                              .format("YYYY-MM-DD")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("摘要"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [_vm._v(" " + _vm._s(item.summary) + " ")]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
            ],
            2
          ),
        ],
        2
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      _c("van-notice-bar", {
        attrs: {
          scrollable: "",
          text: "流程审批须知：请务必留意，审批流程的确定需依据成本归属部门进行。即，成本归属于哪个部门，则需由该部门的相关人员进行审批。",
        },
      }),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            attrs: {
              actCurrentNode: _vm.processData.actCurrentNode || "",
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-35", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("relativeFlow", {
        attrs: { show: _vm.relativeFlow.show, groupId: "11" },
        on: {
          finish: _vm.relativeFlowFinish,
          close: function ($event) {
            _vm.relativeFlow.show = false
          },
        },
      }),
      _c("account", {
        attrs: { show: _vm.account.show },
        on: {
          finish: _vm.accountFinish,
          close: function ($event) {
            _vm.account.show = false
          },
        },
      }),
      _c("imprest", {
        attrs: { show: _vm.imprest.show },
        on: {
          finish: _vm.imprestFinish,
          close: function ($event) {
            _vm.imprest.show = false
          },
        },
      }),
      _c("invoice", {
        ref: "invoice",
        attrs: { show: _vm.invoice.show },
        on: { close: _vm.invoiceClose, success: _vm.invoiceSuccess },
      }),
      _c(
        "van-popup",
        {
          staticStyle: {
            "max-height": "70%",
            overflow: "auto",
            width: "calc(100% - 20px)",
          },
          model: {
            value: _vm.PdfPreviewShow,
            callback: function ($$v) {
              _vm.PdfPreviewShow = $$v
            },
            expression: "PdfPreviewShow",
          },
        },
        [
          _c("PdfPreview", {
            ref: "PdfPreviewPop",
            attrs: { "pdf-url": _vm.PdfPreviewPopFilePath },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }